export class NativeStartRejectedError extends Error {
  constructor(reason: string) {
    super(reason);
    this.name = 'NativeStartRejectedError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
